import { Sidebar, SidebarContent, SidebarRail } from '@/components/ui/sidebar'
import SidebarBrand from './sidebar/SidebarBrand'
import SidebarSearch from './sidebar/SidebarSearch'
import SidebarNav from './sidebar/SidebarNav'
import SidebarTools from './sidebar/SidebarTools'
import SidebarAccountMenu from './sidebar/SidebarAccountMenu'

interface AppSidebarProps {
  initials: string
  onLogin: () => void
  onLogout: () => void
}

export default function AppSidebar({ initials, onLogin, onLogout }: AppSidebarProps) {
  return (
    <Sidebar collapsible="icon" className="border-r">
      <SidebarBrand />
      <SidebarSearch />

      <SidebarContent>
        <SidebarNav />
        <SidebarTools />
      </SidebarContent>

      <SidebarAccountMenu initials={initials} onLogin={onLogin} onLogout={onLogout} />
      <SidebarRail />
    </Sidebar>
  )
}
